import React from "react";

export function useValueRef<T>(v: T) {
  const ref = React.useRef(v);
  ref.current = v;
  return ref;
}